<template>
  <a-layout-sider collapsible class="ehf-sider" width="200" v-model:collapsed="collapse" :class="classObj" :trigger="null">
    <ehf-logo />

    <div class="scrollbar">
      <div class="scrollbar-content">
        <a-menu class="ehf-menu" theme="dark" mode="inline" :selectedKeys="selectedKeys" v-model:openKeys="openKeys">
          <ehf-index-menu v-for="route in routes" :key="route.path" :item="route" />
        </a-menu>
      </div>
    </div>
  </a-layout-sider>
</template>

<script>
  import EhfIndexMenu from './ehf-index-menu'
  import EhfLogo from '../ehf-logo'
  import { mapGetters } from 'vuex'
  import { provide, reactive, ref } from 'vue'
  import { useRouter } from 'vue-router'
  export default {
    name: 'EhfSide',
    components: {
      EhfLogo,
      EhfIndexMenu,
    },
    setup() {
      const router = useRouter()
      let selectedKeys = reactive([])
      let openKeys = ref([])
      const handleNavChange = ({ path, matched, query, meta }) => {
        const tabUrl = meta.tabUrl
        if (tabUrl) {
          selectedKeys = [path + '_tab_' + query.tab]
        } else {
          matched[0].children.length > 1 || matched[0].meta.alwaysShow ? (selectedKeys = [path]) : (selectedKeys = [matched[0].path])
        }
        openKeys.value = [matched[0].path]
      }
      const resetSelectedKeys = () => {
        handleNavChange(router.currentRoute.value)
      }
      provide('selectedKeys', selectedKeys)
      provide('openKeys', openKeys)
      provide('resetSelectedKeys', resetSelectedKeys)
      return {
        selectedKeys,
        openKeys,
        handleNavChange,
      }
    },
    data() {
      return {}
    },
    watch: {
      $route: {
        handler({ path, matched, query, meta }) {
          const tabUrl = meta.tabUrl
          if (tabUrl) {
            this.selectedKeys = [path + '_tab_' + query.tab]
          } else {
            this.selectedKeys = [path]
          }
          this.openKeys = [matched[0].path]
        },
        immediate: true,
      },
    },
    computed: {
      ...mapGetters({
        collapse: 'settings/collapse',
        routes: 'routes/addRouters',
      }),
      classObj() {
        return {
          'ehf-collapse': this.collapse,
        }
      },
    },
  }
</script>

<style lang="scss" scoped>
  .scrollbar {
    overflow: hidden;
    height: calc(100% - 75px);
  }

  .scrollbar-content {
    height: 100%;
    overflow-y: scroll;
    overflow-x: hidden;
    margin-right: -10px; /* 隐藏右侧滚动条 */
    margin-bottom: -10px; /* 隐藏底部滚动条 */
  }
  .ehf-sider {
    position: fixed;
    left: 0;
    height: 100vh;
    overflow: auto;
  }
</style>
